import React, { useState } from "react";
import DataServiceSQL from "../DataService/DataServiceSQL";
import { withStyles } from '@material-ui/core';
import * as Constants from '../Pages/Constants';
import axios from "axios";
import {FormattedMessage} from 'react-intl';


const UpdateStaffRole = (props) => {

  const [submitted, setsubmitted] = useState(false);
  const [displayButtons, setDisplayButtons] = useState(true);
  const [message, setmessage] = useState( <FormattedMessage id="staff.deleteVerification" defaultMessage="Do you want to remove the rights of staff " values={{ID: props.id}} /> );

  const updateRole = () => {
    let data = {
      "resourceType" : "Practitioner",
      "role":"registered"
    }
    DataServiceSQL.updatePractitionnerReq_fhir(props.id, data)
      .then(async (response) => {
        setmessage(<FormattedMessage id="message.success" defaultMessage="Success !" />);
        setDisplayButtons(true);
        setsubmitted(true);
      })
      .catch((e) => {
        setmessage(<FormattedMessage id="message.error.del.user" defaultMessage="Oups, did not work... (err_code del_user)" />);
        setDisplayButtons(true);
        setsubmitted(true);
      });
  }

  const { classes } = props;

  return (
    <div className={classes.popup_background}>
      <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form">
          {submitted ? (
            <div>
              <center>
              <h4>{message}</h4>
              <button onClick={props.closeAfterDelete} className="btn btn-success">
                <FormattedMessage id="button.close" defaultMessage="Close" />
              </button>
              </center>
            </div>
          ) 
          :
          (
            <div>
              <center>
                <h4>{message}</h4>
                {displayButtons ? (
                  <div>
                    <button onClick={props.cancelPopup} className="btn btn-danger">
                      <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                    </button>
                    <b>&emsp;</b>
                    <button onClick={updateRole} className="btn btn-success">
                      <FormattedMessage id="button.submit" defaultMessage="Submit" />
                    </button> 
                  </div>
                )
                :
                null
                }
              </center>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withStyles(Constants.styles)(UpdateStaffRole);